import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Tooltip,
} from "antd";
import { FormInstance } from "antd/lib/form/Form";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Item } from "types/models/colums-table-type";
import type { InputRef } from "antd";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { Rule } from "antd/es/form";
import moment from "moment";
import { formatDateToString } from "helper/common";

const { INPUT, DATE, CURRENCY, SELECT, AUTO_COMPLETE } = FIELD_TYPE;

type EditableRowProps = {
  index: number;
};
export type EditableCellProps = {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  handleSave: (record, index) => void;
  rules: Rule[];
  disabled: boolean;
  value: any;
  onSearch: (record, index) => void;
  onSelect: (record, index) => void;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  const [form] = Form.useForm();
  const onFinishFailed = (errorInfo: any) => {};

  return (
    <Form form={form} component={false} onFinishFailed={onFinishFailed}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  onSearch,
  onSelect,
  name,
  index,
  type,
  rules,
  disabled,
  value,
  ...restProps
}) => {
  // console.log("🚀 ~ record:", record);
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;
  const [inputValue, setInputValue] = useState({});
  const changeInputRef = useRef<any>();
  const onKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
  };
  const handleSetFieldValue = (dataIndex, value) => {
    form.setFieldValue(dataIndex, value);
    setInputValue({ ...inputValue, [dataIndex]: value });
    handleSave(form.getFieldsValue(), index);
  };

  const setTongTien = () => {
    const soLuongBan = form.getFieldValue("soLuongBan");
    const donGia = form.getFieldValue("donGia");
    const vat = form.getFieldValue("vat");
    const tongTien = (soLuongBan * donGia * (100 + vat)) / 100;
    handleSetFieldValue("tongTien", tongTien);
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [editing]);

  const toggleEdit = () => {
    // setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  // const handleSetFieldValue = (dataIndex, value) => {
  //   form.setFieldValue(dataIndex, value);
  //   setInputValue({ ...inputValue, [dataIndex]: value });
  //   handleSave(form.getFieldsValue(), index);
  // };
  // const save = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     toggleEdit();
  //     handleSave({ ...record, ...values }, index);
  //   } catch (errInfo) {
  //
  //   }
  // };

  let childNode = children;

  if (type === INPUT) {
    childNode = (
      // editing ? (
      <Form.Item
        rules={rules}
        style={{ margin: 0 }}
        name={dataIndex}
        initialValue={record[dataIndex]}
      >
        <Input
          // defaultValue={dataIndex === 'nhanVienLayMau' ? localStorage.getItem("username") : ""}
          disabled={disabled}
          style={{
            padding: "4px",
            border: "1px solid #EBEBF0",
            borderRadius: "4px",
          }}
          onChange={async (e) => {
            setInputValue({ ...inputValue, [dataIndex]: e.target.value });
            handleSave(form.getFieldsValue(), index);
          }}
        />
      </Form.Item>
    );
  }
  if (type == AUTO_COMPLETE) {
    childNode = (
      <Form.Item name={dataIndex} initialValue={record[dataIndex]}>
        <AutoComplete
          options={options}
          // onSelect={onSelect}
          // onSearch={(e)=>onSearch}
          onChange={(e) => {
            setInputValue({ ...inputValue, [dataIndex]: e });
            handleSave(form.getFieldsValue(), index);
          }}
        ></AutoComplete>
      </Form.Item>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
